import React from 'react'

export default function Skills() {
  return (
    <div>
      <div className="ml-4 mr-4 md:ml-20 md:mr-20">
        <div class="bg-black p-4 rounded-lg p-10 m-4 md:p-20 md:m-20">
          <h2 className="text-2xl md:text-4xl text-white text-center font-bold mb-4 ">
            Skill
          </h2>
          <br />

          <div className="grid md:grid-cols-2 gap-4 ">
            <div className="flex flex-col items-center">
              <div class="mt-4 mb-10">
                <h1 className="text-white text-xl font-bold">MERN</h1>

                <div className="bg-gray-400 w-64 h-4 rounded-lg mt-2 overflow-hidden">
                  <div className="bg-cyan-500 w-5/6 h-full rounded-lg shadow-md"></div>
                </div>
              </div>

              <div className="mt-4 mb-10">
                <h1 className="text-white text-xl font-bold">MySQL</h1>

                <div className="bg-gray-400 w-64 h-4 rounded-lg mt-2 overflow-hidden">
                  <div className="bg-cyan-500 w-3/4 h-full rounded-lg shadow-md"></div>
                </div>
              </div>

              <div className="mt-4 mb-10">
                <h1 className="text-white text-xl font-bold">CPP</h1>

                <div className="bg-gray-400 w-64 h-4 rounded-lg mt-2 overflow-hidden">
                  <div className="bg-cyan-500 w-4/5 h-full rounded-lg shadow-md"></div>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center">
              <div className="mt-4 mb-10">
                <h1 className="text-white text-xl font-bold">Web Design</h1>

                <div className="bg-gray-400 w-64 h-4 rounded-lg mt-2 overflow-hidden">
                  <div className="bg-cyan-500 w-2/3 h-full rounded-lg shadow-md"></div>
                </div>
              </div>

              <div className="mt-4 mb-10">
                <h1 className="text-white text-xl font-bold">Figma</h1>

                <div className="bg-gray-400 w-64 h-4 rounded-lg mt-2 overflow-hidden">
                  <div className="bg-cyan-500 w-4/6 h-full rounded-lg shadow-md"></div>
                </div>
              </div>

              <div className="mt-4 mb-10">
                <h1 className="text-white text-xl font-bold">GitHub</h1>

                <div className="bg-gray-400 w-64 h-4 rounded-lg mt-2 overflow-hidden">
                  <div className="bg-cyan-500 w-2/4 h-full rounded-lg shadow-md"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
